export default __webpack_public_path__ + "static/media/Goal_15.158b0cbb.zip";